// extracted by mini-css-extract-plugin
module.exports = {"drawer":"Drawer_drawer__2GLKk","drawer--size-medium":"Drawer_drawer--size-medium__2rHGc"};